import React from 'react';
import classnames from 'classnames';
import './IensoConnectionStatusBadge.scss';
import { translate } from 'src/redux/service/i18n';

const STATUS_CONNECTED = 'CONNECTED';
const STATUS_DEVICE_CONNECTED = 'DEVICE_CONNECTED';
const STATUS_DISCONNECTED = 'DISCONNECTED';
const STATUS_DEVICE_DISCONNECTED = 'DEVICE_DISCONNECTED';

const getStatusKey = (status) => {
  switch (status) {
    case STATUS_CONNECTED:
    case STATUS_DEVICE_CONNECTED:
      return 'connected';
    case STATUS_DISCONNECTED:
    case STATUS_DEVICE_DISCONNECTED:
      return 'offline';
    default:
      return 'unregistered';
  }
};

const getStatusLabel = (status) => {
  switch (status) {
    case STATUS_CONNECTED:
    case STATUS_DEVICE_CONNECTED:
      return translate('DeviceSettings.Connected');
    case STATUS_DISCONNECTED:
    case STATUS_DEVICE_DISCONNECTED:
      return translate('DeviceSettings.Offline');
    case 'N/A':
      return translate('DeviceSettings.Unregistered');
    default:
      return '-';
  }
};

export const IensoConnectionStatusBadge = ({ status, label }) => {
  const statusKey = getStatusKey(status);

  return (
    <div className="ienso-connection-status-badge">
      {label && <span className="badge-label">{label}: </span>}
      <span className={classnames('badge-value', `badge-value--${statusKey}`)}>
        <span className="badge-dot" />
        {getStatusLabel(status)}
      </span>
    </div>
  );
};

IensoConnectionStatusBadge.defaultProps = {
  status: null,
  label: null,
};
